import React from 'react';
import dowJones from '../../assets/img/dow_jones.png';

export function PoweredByDowJones() {
  return (
    <div
      style={{
        paddingTop: '20px',
        paddingBottom: 0,
        marginBottom: 0,
      }}
    >
      <img
        style={{
          width: '100px',
        }}
        src={dowJones}
        alt='Powered by Dow Jones'
      />
    </div>
  );
}

export default PoweredByDowJones;
